import React, {useState } from "react";
import { Col, FormGroup, Row, Form, Button, Container } from "react-bootstrap";
import { Breadcrumb, LoginHeader } from "../../components";
import { Input } from 'antd';
import { Link } from "react-router-dom";
function ChangePassword() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Change Password',
        },
    ];


    const Eye=()=>{
        if(password==="password"){
            setpassword("text");
            seteye(false);
        }
        else{
            setpassword("password");
            seteye(true);
        }
    }
    const Eye2=()=>{
        if(password2==="password"){
            setpassword2("text");
            seteye2(false);
        }
        else{
            setpassword2("password");
            seteye2(true);
        }
    }
    const Eye3=()=>{
        if(password3==="password"){
            setpassword3("text");
            seteye3(false);
        }
        else{
            setpassword3("password");
            seteye3(true);
        }
    }
    const[eye,seteye]=useState(true);
    const[password,setpassword]=useState("password");
    const[eye2,seteye2]=useState(true);
    const[password2,setpassword2]=useState("password");
    const[eye3,seteye3]=useState(true);
    const[password3,setpassword3]=useState("password");

    return (
        <>
            <LoginHeader />
            <div className="main-content changePage">
                {/* page content */}
                <div className="pageContent">
                    <div className="pageContent_wide">
                        <Container className="container-lg">
                            <div className="d-flex justify-content-between">
                                <Breadcrumb title="Change Password" breadcrumb={breadcrumb} />
                                <Link to="/dashboard" className="btn btn-outline-info btn-sm mt-0">Back</Link>
                            </div>
                            <div className="br-10 p-30 bg-white">
                                <Form>
                                    <Row>
                                        <Col sm={12}>
                                            <FormGroup className="form-group">
                                            <label className="ant-label">Old Password</label>
                                            <div className="position-relative">
                                                <Input type={password}  size="large" placeholder="Old Password" />
                                                <Link className=" input-icon">         
                                                    <i onClick={Eye} className={`fa ${eye ? "gg-eye-off" : "gg-eye-on" }`}></i>
                                                </Link>
                                            </div>
                                            </FormGroup>
                                        </Col>
                                        <Col sm={12}>
                                            <FormGroup className="form-group">
                                                <label className="ant-label">New Password</label>
                                                <div className="position-relative">
                                                    <Input type={password2}  size="large" placeholder="New Password" />
                                                    <Link className=" input-icon">         
                                                        <i onClick={Eye2} className={`fa ${eye2 ? "gg-eye-off" : "gg-eye-on" }`}></i>
                                                    </Link>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col sm={12}>
                                            <FormGroup className="form-group mb-0">
                                                <label className="ant-label">Confirm Password</label>
                                                <div className="position-relative">
                                                    <Input type={password3}  size="large" placeholder="Confirm Password" />
                                                    <Link className=" input-icon">         
                                                        <i onClick={Eye3} className={`fa ${eye3 ? "gg-eye-off" : "gg-eye-on" }`}></i>
                                                    </Link>
                                                 {/* <label className="ant-label"></label> */}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col sm={12}>
                                            <Button variant="primary" className="ms-auto min-200 btn-lg">Save</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ChangePassword;